import { render, staticRenderFns } from "./cogsCharttextOnly.vue?vue&type=template&id=8d262940&scoped=true"
import script from "./cogsCharttextOnly.vue?vue&type=script&lang=js"
export * from "./cogsCharttextOnly.vue?vue&type=script&lang=js"
import style0 from "./cogsCharttextOnly.vue?vue&type=style&index=0&id=8d262940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d262940",
  null
  
)

export default component.exports